<template lang="pug">
// main(@mousemove="resetTimeoutBloqueo", @keypress="resetTimeoutBloqueo")
main
	toasts(style="z-index: 2001;")
	alertas(style="z-index: 2002;")
	transition(name="esperar")
		router-view(v-show="!sesionBloqueada", style="z-index: 1")
	// component(:is="'chat-container'")
	contextual(style="z-index: 2003;")
	cambio-pass(v-if="cambiarPass")
	transition(name="slide-down")
		bloqueo(:usuario="sesionBloqueada", v-if="sesionBloqueada", style="z-index:2000")
	modal(v-if="verTutorialNotificaciones")
		.card
			.card-header.bg-danger.text-white
				span.fa.fa-info-circle.mr-2
				| Atención
			h5.card-body.bg-light Debes aceptar las notificaciones de este sitio web
			div
				img(src="/src/modulos/core/static/notificaciones.gif", title="Notificaciones")
</template>

<script>

import Alertas from './components/common/alertas'
import { mapGetters } from 'vuex'
import axios from 'axios'
import CambioPass from './components/mi-perfil/cambio-pass.vue'
import Bloqueo from './components/login/bloqueo'
import Toasts from './components/toasts/wrapper'
import MenuContextual from './components/contextual/contextual.vue'

export default {
	name: 'app',
	data () {
		return {
			cambiarPass: false,
			intervaloSesion: null,
			intervaloPermisos: null,
			sesionBloqueada: null,
			timeoutBloqueo: null,
			timeoutAvisoBloqueo: null,
			minutosAutoBloqueo: 30,
			verTutorialNotificaciones: false,
			moduloActivo: null
		}
	},
	components: {
		'alertas': Alertas,
		'cambio-pass': CambioPass,
		'bloqueo': Bloqueo,
		'toasts': Toasts,
		'contextual': MenuContextual
	},
	computed: {
		...mapGetters({
			sesion: 'session/haySesion',
			permisos: 'permisos/permisos',
			afterLoginPath: 'session/afterLoginPath'
		})
	},
	beforeCreate: function () {
		// Cuando la sesión está bloqueada solo permitiremos peticiones a /src/modulos/core/php/api/{get.php,desbloquear.php,logout.php}
		this.$moment.locale('es')
		const cancelToken = axios.CancelToken
		const source = cancelToken.source()
		axios.interceptors.request.use((req) => {
			const url = req.url
			const permitidas = [
				'core/php/api/sesion/get.php',
				'core/php/api/sesion/desbloquear.php',
				'core/php/api/sesion/logout.php'
			]

			if (this.sesionBloqueada && permitidas.indexOf(url) < 0) {
				req.cancelToken = source.token
				source.cancel()
				return
			}
			return req
		},
		(err) => {
			return Promise.reject(err)
		})

		// Interceptamos los 401
		axios.interceptors.response.use((res) => {
			return res
		},
		(err) => {
			if (!err.response) {
				throw new axios.Cancel({
					code: 423,
					message: 'Sesión bloqueada'
				})
			} else if (err.response.status === 423) {
				this.$store.commit('session/setBloqueado', err.response.data.usuario)
				throw new axios.Cancel({
					code: 423,
					message: 'Sesión bloqueada'
				})
			} else if (err.response.status === 401) {
				// Si la ruta es para resetear password no redireccionamos
				if (!this.$route.path.match(/^\/password-restore/)) {
					this.$router.push('/login')
				}
			} else {
				if (!err.response.data.error) {
					err.response.data = {
						error: 'Error desconocido'
					}
				}
				return Promise.reject(err)
			}
		})

		this.$store.watch(
			(a) => a.session.activa,
			(newValue, oldValue) => {
				if (newValue === false) {
					if (this.$route.path.match(/^\/password-restore/)) {
						return
					}
					if (oldValue === null && this.$route.path !== '/login') {
						// Almacenamos la url para acceder despues del login
						this.$store.commit('session/SET_AFTER_LOGIN', this.$route.path)
					}
					this.$router.push('/login')

					if (this.intervaloSesion) {
						window.clearInterval(this.intervaloSesion)
					}

					if (this.intervaloPermisos) {
						window.clearInterval(this.intervaloPermisos)
					}
				} else {
					if (!oldValue && this.afterLoginPath) {
						this.$router.push(this.afterLoginPath)
					} else if (!this.$route.path.match(/^\/main/)) {
						this.$router.push('/main')
					}

					this.$store.dispatch('permisos/getPermisos')

					this.intervaloSesion = window.setInterval(() => {
						this.$store.dispatch('session/getSesion')
					}, 10000)

					this.intervaloPermisos = window.setInterval(() => {
						this.$store.dispatch('permisos/getPermisos')
					}, 60000)
				}
			}
		)

		this.$store.watch(
			(a) => a.session.cambioPass,
			(nuevo) => {
				if (nuevo === true) {
					this.cambiarPass = true
				} else {
					this.cambiarPass = false
				}
			}
		)

		this.$store.watch(
			(a) => a.session.bloqueado,
			(nuevo) => {
				this.sesionBloqueada = nuevo
			}
		)

		this.$store.dispatch('session/getSesion')

		this.$router.beforeEach((to, from, next) => {
			const ruta = to.path.split('/')
			if (this.moduloActivo !== null && this.moduloActivo !== ruta[2]) {
				console.log(this.moduloActivo + '!=' + ruta[2])
				this.$store.commit('top/clearMenu')
			}
			this.moduloActivo = ruta[2]
			if (to.path.match(/^\/password-restore/)) {
				next()
			} else if (!this.sesion && to.path !== '/login') {
				this.$router.push('/login')
			} else if (!this.session && to.path === '/login') {
				next()
			} else if (!to.path.match(/^\/main/)) {
				this.$router.push('/main')
			} else {
				next()
			}
		})
	},
	created () {
		// Preguntamos por el permiso de notificaciones
		if (window.Notification && (Notification.permission === 'denied' || Notification.permission === 'default')) {
			Notification.requestPermission()
				.then(permiso => {
					if (permiso === 'denied') {
						// this.verTutorialNotificaciones = true
						// No obligamos a que acepten las notificaciones
					}
				})
				.catch(e => {
					console.error(e)
				})
		}
	},
	methods: {
		bloquear () {
			this.$store.dispatch('session/lock')
		}
	}
}
</script>

<style>
html {
	font-size: 12px;
}
body {
	margin: 0;
	overflow-x: hidden;
	font-family: 'Roboto', sans-serif;
}

#app {
	/* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

main {
	text-align: center;
	/*font-size: 0.8em;*/
	margin: 0;
}


input[type=checkbox] {
	width: 20px;
	height: 20px;
	border-radius: 0;
	background-color: white;
	border: 1px solid #e0e0e0;
	vertical-align: middle;
}

#fondoModal {
	position: fixed;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: scroll;
	-webkit-overflow-scrolling: touch;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2000;
}

#fondoModal > div:first-of-type {
	position: relative;
	display: block;
	text-align: center;
	margin-top: 20px;
}

#fondoModal > div:first-of-type > div:first-of-type {
	position: relative;
	display: inline-block;
	max-width: 900px;
	width: 100%;
	margin-top: 20px;
}


.fondoModal {
	position: fixed;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: scroll;
	-webkit-overflow-scrolling: touch;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2000;
}

.fondoModal > div:first-of-type {
	position: relative;
	display: block;
	text-align: center;
	margin-top: 20px;
}

.fondoModal > div:first-of-type > div:first-of-type {
	position: relative;
	display: inline-block;
	max-width: 900px;
	width: 100%;
	margin-top: 20px;
}

/* TRANSICIONES */
.slide-down-enter-active, .slide-down-leave-active {
  transition: transform 2s ease-in-out;
}
.slide-down-enter, .slide-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-2000px);
}

.esperar-enter-active {
	transition: all 1ms;
	transition-delay: 0s;
}
.esperar-leave-active {
  transition: all 1ms;
  transition-delay: 2s;
}
.esperar-enter, .esperar-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/App.vue